export default __webpack_public_path__ + "maps-examples-draggable-views-thumbnail-960-3c4eee583f378a26a6fcc6b6c4cc337c.webp";